import { modalsConstants } from '../utils/types';
import { modals } from '../utils/constants';

export default function modalsReducer(state = { modal: modals.NONE }, action) {
  switch (action.type) {
  case modalsConstants.OPEN_MODAL:
    return {
      modal: action.payload.modal,
      modalData: action.payload.modalData
    };
  case modalsConstants.RESET:
    return { modal: modals.NONE };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modalsReducer.js